module.exports = __webpack_public_path__ + "static/media/hcc_logo.f77023fa.svg";